export default __webpack_public_path__ + "static/media/stream-not-found.101dd861.svg";